import { LTRIcon, UTDIcon } from "../../Icons/BackgroundFillIcons";

export const BannerStyles = {
  SIMPLE: "simple",
  STYLED: "styled",
};

export const ContentDirections = {
  LTR: "ltr",
  UTD: "utd",
};

export const BackgroundTabTypes = {
  COLOR: "solid_color",
  IMAGE: "image_bg",
};

export const ChooseImageTabTypes = {
  UNSPLASH: "unsplash",
  LINK: "link",
};

export const ContentDirectionTabs = [
  {
    id: ContentDirections.LTR,
    Icon: LTRIcon,
  },
  {
    id: ContentDirections.UTD,
    Icon: UTDIcon,
  },
];
